import { AlertWrapper } from 'components/core-v2'

import { useAppSelector } from '../store/hooks'
import { Errors } from './validator'

type AlertTextProps = {
  text: string
}

type CustomAlertProps = {
  errors?: Errors
}

type AlertProps = {
  errorName: string
} & CustomAlertProps

const AlertText = ({ text }: AlertTextProps) => (
  <AlertWrapper className="mt-8">
    <span>{text}</span>
  </AlertWrapper>
)

const Alert = ({ errorName, errors }: AlertProps) => {
  const builderState = useAppSelector(state => state.builder)
  const err = errors || builderState?.errors

  if (!err || !err[errorName]) {
    return null
  }

  return <AlertText text={err[errorName]} />
}

export const CollateralAlert = ({ errors }: CustomAlertProps) => (
  <Alert errorName="collateral" errors={errors} />
)

export const TradingStatusClosedAlert = ({ errors }: CustomAlertProps) => (
  <Alert errorName="tradingStatusClosed" errors={errors} />
)
